<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Profile Side Panel"
    seFeDataSubtitle="A profile side panel component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component to display a side panel with the profile header</p>
      </se-fe-card-content>
    </se-fe-card>

    @for (n of models; track n) {
      <se-fe-card>
        <se-fe-card-header [seFeDataTitle]="n"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers[n]"
            [seFeDataRows]="rows[n]">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>
    }

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-profile-side-panel-example></se-po-profile-side-panel-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
